import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import HomePage from './pages/HomePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import DynamicThemeProvider from './components/theme/DynamicThemeProvider';

// Importe os componentes de gerenciamento
import ManageSiteContent from './components/admin/ManageSiteContent';
import ManageServices from './components/admin/ManageServices';
import ManageGallery from './components/admin/ManageGallery';
import ManageTestimonials from './components/admin/ManageTestimonials';

function App() {
  return (
    <Router>
      <DynamicThemeProvider> {/* Envolve todas as rotas */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminLoginPage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="content" replace />} />
            <Route path="content" element={<ManageSiteContent />} />
            <Route path="services" element={<ManageServices />} />
            <Route path="gallery" element={<ManageGallery />} />
            <Route path="testimonials" element={<ManageTestimonials />} />
          </Route>
        </Routes>
      </DynamicThemeProvider>
    </Router>
  );
}

export default App;
